import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useNotification } from "@hooks/useNotification";
import { useQuery } from "@hooks/useQuery";
import { useDocumentDetails } from "@modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { decodeHTML } from "@utils/CommonUtils";
import { useEffect } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { useAuth } from "~/Hooks/useAuth";
import { post, put } from "~/Services";
import { eramanHost } from "~/Utils";
import { useNews } from "../../Pages.hook";
import { fields } from "../../constants";

export const AddEditNews = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const { openToast } = useNotification();
  const { user } = useAuth();

  const {
    data: editNewsData,
    error,
    isLoading: drilldownLoading,
    isError,
    refetch: refetcheditNews,
  } = useNews(query.get("editId") || "");

  console.log(editNewsData, "editNewsData");

  const {
    data: newsById,
    isLoading: isLoadingNews,
    refetch: refetchDocument,
  } = useDocumentDetails(query?.get("id") || "");

  useEffect(() => {
    if (query.get("id")) {
      refetchDocument();
    }
    if (query.get("editId")) {
      refetcheditNews();
    }
  }, [query.get("editId"), query.get("id")]);

  const editNews = editNewsData as any;
  console.log(editNews?.[0], "datanews");

  const newsFormConfig: FormConfig = {
    initialValues: {
      title: decodeHTML(newsById ? newsById.payload.title : editNewsData ? editNewsData?.[0]?.title : ""),
      field_common_malay_title: decodeHTML(
        newsById
          ? newsById.payload.field_common_malay_title
          : editNewsData
            ? editNewsData?.[0]?.field_common_malay_title
            : ""
      ),
      field_common_mandarin_title: decodeHTML(
        newsById
          ? newsById.payload.field_common_mandarin_title
          : editNewsData
            ? editNewsData?.[0]?.field_common_mandarin_title
            : ""
      ),
      date: decodeHTML(newsById ? newsById.payload.date : editNewsData ? editNewsData?.[0]?.date : ""),
      body: decodeHTML(newsById ? newsById.payload.body : editNewsData ? editNewsData?.[0]?.body : ""),
      field_common_malay_description: decodeHTML(
        newsById
          ? newsById.payload.field_common_malay_description
          : editNewsData
            ? editNewsData?.[0]?.field_common_malay_description
            : ""
      ),
      field_common_mandarin_descriptio: decodeHTML(
        newsById
          ? newsById.payload.field_common_mandarin_descriptio
          : editNewsData
            ? editNewsData?.[0]?.field_common_mandarin_descriptio
            : ""
      ),
      newsImage: newsById?.payload
        ? decodeHTML([
            {
              uid: "-1",
              name: "newsImage.png",
              status: "done",
              url: newsById?.payload?.newsImage,
            },
          ])
        : decodeHTML([
            {
              uid: "-1",
              name: "newsImage.png",
              status: "done",
              url: editNewsData?.[0]?.newsImage,
            },
          ]),
      published: decodeHTML(newsById ? newsById.payload.published : editNewsData ? editNewsData?.[0]?.published : ""),
    },
    fields: fields.news,
  };

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    let imageKeys: any = ["newsImage"];
    for (const key of imageKeys) {
      const field = data[key];

      try {
        if (field?.[0]?.originFileObj) {
          const formData = new FormData();
          formData.append("upload-file", field[0].originFileObj);
          formData.append("application", "ERAMAN");
          const res: any = await post("management/upload-file", formData);
          if (res) data[key] = res.response.data;
        } else if (field?.[0]?.url) {
          data[key] = field[0].url;
        } else if (Array.isArray(field) && field.length === 0) {
          data[key] = "";
        } else if (!field) {
          data[key] = "";
        }
      } catch (error) {
        console.error(`Error handling image field ${key}:`, error);
      }
    }

    const payload = {
      action: action,
      method: method,
      module: "Pages",
      subModule: "aboutEraman_news",
      type: "DEDICATED",
      application: "ERAMAN",
      reviewNotes: reviewNotes,
      appList: [
        {
          appName: "ERAMAN",
          apiUrl: apiUrl,
        },
      ],
      payload: {
        ...data,
        id: editNewsData?.[0]?.id || newsById?.payload?.id,
        // published: true,
      },
      status: status,
    };
    if (query.get("id")) {
      put(`/management/update-document?approvalId=${query.get("id")}`, payload)
        .then((response: any) => {
          openToast({
            content: status == "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    } else {
      post("/management/publish", payload)
        .then((response: any) => {
          openToast({
            content: status == "DRAFT" ? "Data saved successfully" : "Data Sent for Review",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
          // refetchDocument();
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    }
  };

  return (
    <ContentWrapper
      title={`${query.get("id") || query.get("editId") ? "Edit" : "Add New"} News`}
      showBack
    >
      <DynamicForm
        isLoading={isLoadingNews || drilldownLoading}
        config={newsFormConfig}
        onSubmit={(data, buttonValue, reviewNotes) =>
          onSubmit(
            data,
            `${query.get("editId") ? `${eramanHost}/api/news-list-detail-list-page-crud-api/${editNewsData?.[0]?.id || newsById?.payload?.id}` : `${eramanHost}/api/create/news-list-detail-list-page-crud-api`}`,
            `${query.get("editId") ? "UPDATE" : "CREATE"}`,
            `${query.get("editId") ? "PATCH" : "POST"}`,
            buttonValue == "save" ? "DRAFT" : "PENDING",
            reviewNotes
          )
        }
      />
    </ContentWrapper>
  );
};
